// Scroll a comment into view and briefly highlight it (see CommentItem's
// `data-[highlight]` style). Shared by CommentsList (deep-link on load) and
// NotificationItem (same-page click).
export function scrollToComment(commentId: string | number) {
  const el = document.getElementById(`comment-${commentId}`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.dataset.highlight = 'true';
  setTimeout(() => {
    delete el.dataset.highlight;
  }, 2000);
}
